// extracted by mini-css-extract-plugin
module.exports = {"container":"safe-build_container_14gis","noDataBox":"safe-build_noDataBox_1q9dt","icon":"safe-build_icon_U63hm","chartBox":"safe-build_chartBox_2sxmV"};